import { render, staticRenderFns } from "./skillarea.vue?vue&type=template&id=7a521834&scoped=true&"
import script from "./skillarea.vue?vue&type=script&lang=js&"
export * from "./skillarea.vue?vue&type=script&lang=js&"
import style0 from "./skillarea.vue?vue&type=style&index=0&id=7a521834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a521834",
  null
  
)

export default component.exports